<template>
  <div class="info_box_r"><h3 class="h3 mb">Moje poistenie</h3>
    <div class="rw">
      <div class="mb-s">Účel cesty</div>
      <div class="rw_tg_w">
        <InfoBoxValue v-for="(item) in formData.travel_reason" :value="item" :key="item" context="travel_reason" />
      </div>
    </div>
    <div class="rw">
      <div class="mb-s">Kam cestujete</div>
      <div class="rw_tg_w">
        <InfoBoxValue v-if="formData.regional_coverage" :value="formData.regional_coverage" context="regional_coverage" />
      </div>
    </div>
    <div class="rw">
      <div class="mb-s">Ako cestujete</div>
      <div class="rw_tg_w">
        <InfoBoxValue v-for="(item) in (formData.traveling_by || [])" :value="item" :key="item" context="traveling_by" />
<!--        <InfoBoxValue v-if="formData.traveling_by" :value="formData.traveling_by" context="traveling_by" />-->
      </div>
    </div>
    <div class="rw">
      <div class="mb-s">Pripoistenie zrušenia cesty</div>
      <div class="rw_tg_w">
        <InfoBoxValue v-if="formData.storno_type && formData.traveling_by" :value="formData.storno_type" context="storno_type" />
      </div>
    </div>
    <div class="rw">
      <div class="mb-s">Kedy cestujete</div>

      <div class="rw_tg_w" v-if="formData.insurance_from">
        <div class="rw_tg">
          <div class="mr-s">od</div>
          <div class="b">{{ this.formatDateDMY(formData.insurance_from) }}</div>
        </div>
        <div class="rw_tg" v-if="formData.insurance_to">
          <div class="mr-s">do</div>
          <div class="b">{{ this.formatDateDMY(formData.insurance_to) }}</div>
        </div>
      </div>
    </div>
    <div class="rw">
      <div class="mb-s">Počet dní</div>

      <div class="rw_tg_w" v-if="formData.insurance_from && formData.insurance_to && this.daysCount">
        <div class="rw_tg">
          <div class="b">{{ this.daysCount }}</div>
        </div>
      </div>
    </div>
    <div class="rw">
      <div class="mb-s">Počet poistených osôb</div>

      <div class="rw_tg_w" v-if="formData.travellers_count && formData.insurance_from && formData.insurance_to">
        <div class="rw_tg">
          <div class="b">{{ formData.travellers_count }}</div>
        </div>
      </div>
    </div>
    <div class="rw">
      <div class="mb-s">Vek cestujúcich</div>
      <div class="rw_tg_w">
        <div class="rw_tg" v-if="formData.insurance_from && formData.insurance_to">
          <div class="b">Vek

            <span v-if="!formData.age_above_70">do</span>
            <span v-else>nad</span>

            70 rokov</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoBoxValue from "@/components/parts/trip/InfoBoxValue.vue";

export default {
  name: 'InfoBox',
  components: {InfoBoxValue},
  props: {
    daysCount: Number,
    formData: Object
  },
  data() {
    return {
      // Component state
    };
  },
  computed: {
    // Computed properties
  },
  methods: {
    formatDateDMY(date) {
      date = new Date(date);
    const d = String(date.getDate()).padStart(2, '0');
      const m = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const y = date.getFullYear();
      return `${d}.${m}.${y}`;
    }
    // Methods go here
  },
  mounted() {
    // Code to run when component is mounted
  }
};
</script>

<style scoped>
/* Review box
*/
.info_box_r {
  background-color: var(--f2f4f6);
  padding: 21px;
  font-size: 14px;
  line-height: 1.4em;
}

.rw {
  border: 1px solid #bcd;
  border-width: 1px 0;
  margin-bottom: -1px;
  padding-top: 7px;
  padding-bottom: 7px;
}
.rw_tg {
  background-color: #fff;
  justify-content: flex-start;
  align-items: center;
  padding: 4px 11px;
  font-size: 15px;
  font-weight: 100;
  line-height: 1em;
  display: flex;
}
.rw_tg_w {
  grid-column-gap: 4px;
  grid-row-gap: 4px;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.b {
  font-weight: 500;
}
.mr-s {
  margin-right: 4px;
}
</style>
